import { Routes, Route} from "react-router-dom";
import Home from "../components/home/Home"
import Login from "../components/login/Login";
import PrivacyPolicy from "../components/privacy-policy/PrivacyPolicy"
import CreateAccount from "../components/user-account/create-account/CreateAccount"
import Subscription from "../components/user-account/subscription/Subscription"
import Profile from "../components/user-account/profile/Profile"
import SearchImage from "../components/search/SearchImage";
import RequireAuth from "../auth/RequireAuth";

function AppRoute()
{
    return (        
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="login" element={<Login/>}/>
            <Route path="privacypolicy" element={<PrivacyPolicy/>}/>
            <Route path="create-account" element={<CreateAccount/>}/>
            <Route path="subscription" element={
                <RequireAuth>
                    <Subscription/>
                </RequireAuth>}/>
            <Route path="profile" element={
                <RequireAuth>
                    <Profile />
                </RequireAuth>}/>
            <Route path="searchimage" element={
                <RequireAuth>
                    <SearchImage />
                </RequireAuth>}/>
            <Route path="*" element={<Home/>}/>
        </Routes>
    );
}

export default AppRoute;